<template>
  <div class="my-4">
    <v-col cols="12" class="px-1">
      <v-select :items="document_types" v-model="selected_type" outlined label="Document Type"
    /></v-col>
    <v-file-input
      v-model="file"
      color="primary"
      :loading="submitting"
      :disabled="submitting"
      counter
      label="Select File"
      placeholder="Select your file"
      prepend-icon=""
      refs="input"
      outlined
      prepend-inner-icon="mdi-paperclip"
      show-size
      :error="!!error"
      :messages="[error]"
    >
      <template v-slot:selection="{ text }">
        <v-chip color="primary" dark label small>
          {{ text }}
        </v-chip>
      </template>
    </v-file-input>
    <v-btn
      color="primary"
      raised
      :loading="submitting"
      :disabled="submitting || !file"
      block
      large
      rounded
      @click="handleSubmit"
    >
      <v-icon>mdi-upload</v-icon>
      Upload
    </v-btn>
  </div>
</template>
<script>
export default {
  props: {
    uploadUrl: {
      type: String,
      required: true,
    },
    extraFields: {
      required: false,
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    file: null,
    submitting: false,
    selected_type: "transfer-receipts",
    error: null,
    document_types: ["transfer-receipts"],
  }),
  methods: {
    handleSubmit() {
      if (!this.file) {
        return (this.error = "Please upload a file");
      }
      // clear any existing errors
      this.error = null;
      this.submitting = true;
      const formData = new FormData();

      formData.append("file", this.file);
      formData.append("type", this.selected_type);

      //   Object.keys(this.extraFields || {}).forEach((key) =>
      //     formData.append(key, this.extraFields[key]),
      //   );

      this.$http
        .post(this.uploadUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$emit("uploaded", response);
          Notify.success("File was uploaded successfully");
        })
        .catch(({ response }) => {
          this.error =
            this.extractDataKey(response, "data.errors.file.0") || "Something went wrong";
        })
        .finally(() => (this.submitting = false));
    },
  },
};
</script>
